import ProjectVariableTemplates from "./ProjectVariableTemplates";

export default ProjectVariableTemplates;
